var ImageCropperModel = (function () {
    function ImageCropperModel() {
    }
    return ImageCropperModel;
}());
export { ImageCropperModel };
//# sourceMappingURL=imageCropperModel.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ng2-img-cropper/src/model/imageCropperModel.js
// module id = ../../../../ng2-img-cropper/src/model/imageCropperModel.js
// module chunks = 3